import React, {Fragment, useEffect, useState} from "react";
import {useAdvancedSearchMutation} from "../../core/api/rogerthat-state-api";
import AdvancedSearch from "./index";

export default function AdvancedSearchRT() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchMutation} />
}